/*
 * 1-Э1.5 «Принятие приглашения».
 *
 * Числа — из макета «Мастер, доступ и заглушка — П1» (строки 109–127): колонка прокручивается,
 * кнопка закреплена внизу — ровно как на 4-А1 (onboarding.module.css). Контрольная ширина 360:
 * ссылку открывают с телефона, из мессенджера. На широком экране колонка остаётся колонкой.
 * Размеров шрифта 19 и 13 в токенах нет (xl = 18, base = 13.5) — взяты ближайшие токены,
 * расхождение вынесено вопросом дизайнеру.
 */

.page {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100dvh;
  background: var(--bg-workspace);
}

.column {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  max-width: 420px;
  min-height: 0;
  padding: 24px 20px 16px;
  margin: 0 auto;
  overflow: auto;
  font-size: var(--font-size-base);
  line-height: 1.5;
}

.heading {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  line-height: 1.15;
}

.text {
  margin: 0;
  color: var(--text-secondary);
}

.roleCard {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 14px;
}

.roleLabel {
  font-size: 11px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-faint);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.roleName {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
}

.roleSummary {
  color: var(--text-brand);
}

.roleBranches {
  font-size: 11.5px;
  color: var(--text-faint);
}

/* «Вы уже в системе» и прочие пояснения — info-плашка, как в макете (--info-bg / --info-fg). */
.notice {
  padding: 10px 12px;
  color: var(--info-fg);
  background: var(--info-bg);
  border-radius: 12px;
}

.warning {
  padding: 10px 12px;
  color: var(--status-pending-fg);
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.field {
  margin: 0;
}

.field input {
  height: 48px;
  font-size: 16px;
}

/* Два согласия в одной рамке, но разделённые чертой: это два разных документа. */
.consents {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 12px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.consents label {
  align-items: flex-start;
  min-height: 28px;
  font-size: 12.5px;
  line-height: 1.4;
}

.consents input {
  margin-top: 2px;
}

.consentDivider {
  height: 1px;
  background: var(--grid-line-minor);
}

.error {
  font-size: var(--font-size-sm);
  color: var(--danger);
}

.linkButton {
  align-self: flex-start;
  padding: 0;
  font: inherit;
  color: var(--text-brand);
  text-decoration: underline;
  cursor: pointer;
  background: none;
  border: 0;
}

.footer {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  max-width: 420px;
  padding: 8px 20px 14px;
  margin: 0 auto;
  background: var(--bg-workspace);
  border-top: 1px solid var(--border);
}

.footer button {
  width: 100%;
  height: 48px;
  font-size: 14px;
  border-radius: 12px;
}
